import { useEffect, useState } from 'react';
import axios from "axios";
import {
  FaUserMd,
  FaHospital,
  FaTimes,
  FaCheckCircle,
  FaEye,
  FaEyeSlash
} from "react-icons/fa";
import API_URL from "../config";

function LoginModal({ isOpen, onClose, initialRole = "candidate" }) {

const [role, setRole] = useState(initialRole);

useEffect(() => {
  if (isOpen) {
    setRole(initialRole);
    setIsRegister(false);
  }
}, [isOpen, initialRole]);
  const [isRegister, setIsRegister] = useState(false);

// Forgot Password
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetStep, setResetStep] = useState(1);
  const [resetEmail, setResetEmail] = useState("");
  const [resetOtp, setResetOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showConfirmResetPassword, setShowConfirmResetPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({

    // Candidate

    name: "",

    // Recruiter

    organization_name: "",
    organization_type: "",
    city: "",

    // Common

    email: "",
    phone: "",
    password: "",
    confirmPassword: ""

  });

  const organizationTypes = [

    "Government Hospital",
    "Private Hospital",
    "Corporate Hospital",
    "Clinic",
    "Nursing Home",
    "Medical College",
    "Nursing College",
    "Paramedical College",
    "Diagnostic Centre",
    "Blood Bank",
    "Pharmacy",
    "Home Healthcare",
    "Healthcare Startup",
    "NGO / Trust",
    "Other"

  ];

  const cities = [

    "Hyderabad",
    "Bengaluru",
    "Chennai",
    "Mumbai",
    "Delhi",
    "Pune",
    "Vijayawada",
    "Visakhapatnam",
    "Warangal",
    "Nalgonda"

  ];

  if (!isOpen) return null;

  const handleChange = (e) => {

    setForm({

      ...form,

      [e.target.name]: e.target.value

    });

  };

  const resetForm = () => {

    setForm({

      name: "",
      organization_name: "",
      organization_type: "",
      city: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: ""

    });

  };

  const validateRegister = () => {

    if (role === "candidate") {

      if (
        !form.name ||
        !form.phone ||
        !form.email ||
        !form.password ||
        !form.confirmPassword
      ) {

        alert("Please fill all mandatory fields.");

        return false;

      }

    }

    if (role === "institution") {

      if (
        !form.organization_name ||
        !form.email ||
        !form.phone ||
        !form.city ||
        !form.organization_type ||
        !form.password ||
        !form.confirmPassword
      ) {

        alert("Please fill all mandatory fields.");

        return false;

      }

    }

    if (form.password !== form.confirmPassword) {

      alert("Password and Confirm Password do not match.");

      return false;

    }

    if (form.password.length < 6) {

      alert("Password should contain at least 6 characters.");

      return false;

    }

    return true;

  };

  const handleSubmit = async () => {

    try {

      setLoading(true);

      if (isRegister) {

        if (!validateRegister()) {

          setLoading(false);

          return;

        }

        await axios.post(

          `${API_URL}/auth/register`,

          {

            ...form,

            role

          }

        );

        alert("Registration Successful.");

        resetForm();

        setIsRegister(false);

      }

      else {

        const res = await axios.post(

          `${API_URL}/auth/login`,

          {

            phone: form.phone,

            password: form.password,

            role: role

          }

        );

        localStorage.setItem(

          "user",

          JSON.stringify(res.data.user)

        );
        localStorage.setItem(
  "token",
  res.data.token
);

        alert("Login Successful.");

        if (res.data.user.role === "institution") {

          window.location.href = "/institution";

        }

        else {

          window.location.href = "/candidate-dashboard";

        }

      }

    }

    catch (err) {

      console.log(err);

      alert(

        err.response?.data?.message ||

        "Something went wrong."

      );

    }

    finally {

      setLoading(false);

    }

  };
  // =====================================
// FORGOT PASSWORD
// =====================================

const handleForgotPassword = async () => {
  if (!resetEmail.trim()) {
    alert("Please enter your registered email address.");
    return;
  }

  try {
    setLoading(true);

    const normalizedEmail = resetEmail.trim().toLowerCase();
    const response = await axios.post(
      `${API_URL}/auth/forgot-password`,
      { email: normalizedEmail }
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Unable to send OTP.");
    }

    setResetEmail(normalizedEmail);
    alert(response.data.message || "OTP email accepted by the mail server. Check your inbox and spam folder.");
    setResetStep(2);

  } catch (err) {

    console.error("Forgot Password Error:", err);

    alert(
      err.response?.data?.message ||
      err.message ||
      "Unable to send OTP. Please check that the backend server is running."
    );

  } finally {
    setLoading(false);
  }
};


const handleVerifyResetOtp = async () => {

  if (!resetOtp || resetOtp.length !== 6) {
    alert("Please enter the 6-digit OTP.");
    return;
  }

  try {

    setLoading(true);

    await axios.post(
      `${API_URL}/auth/verify-reset-otp`,
      {
        email: resetEmail.trim(),
        otp: resetOtp
      }
    );

    alert("OTP verified successfully.");

    setResetStep(3);

  } catch (err) {

    console.error("Verify OTP Error:", err);

    alert(
      err.response?.data?.message ||
      "Invalid OTP."
    );

  } finally {
    setLoading(false);
  }
};


const handleResetPassword = async () => {

  if (!newPassword || !confirmNewPassword) {
    alert("Please enter both password fields.");
    return;
  }

  if (newPassword.length < 8) {
    alert("Password must be at least 8 characters long.");
    return;
  }

  if (newPassword !== confirmNewPassword) {
    alert("Passwords do not match.");
    return;
  }

  try {

    setLoading(true);

    await axios.post(
      `${API_URL}/auth/reset-password`,
      {
        email: resetEmail.trim(),
        newPassword: newPassword
      }
    );

    alert(
      "Password reset successfully. Please login with your new password."
    );

    // Return to login
    setForgotPassword(false);
    setResetStep(1);

    setResetEmail("");
    setResetOtp("");
    setNewPassword("");
    setConfirmNewPassword("");

  } catch (err) {

    console.error("Reset Password Error:", err);

    alert(
      err.response?.data?.message ||
      "Unable to reset password."
    );

  } finally {
    setLoading(false);
  }
};
  return (

<div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto overscroll-contain bg-black/60 px-2 py-2 backdrop-blur-sm sm:px-4 sm:py-6">

<div className="relative my-auto flex max-h-[calc(100dvh-1rem)] w-full max-w-2xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl sm:max-h-[calc(100dvh-3rem)] sm:rounded-3xl">

{/* CLOSE */}
<button
  onClick={onClose}
  className="
   absolute
    top-2
    right-2
    h-8
    w-8
    sm:top-5
    sm:right-5
    sm:h-10
    sm:w-10
    rounded-full
    bg-white/20
    hover:bg-white
    text-white
    hover:text-teal-600
    flex
    items-center
    justify-center
    transition-colors
    duration-300
    backdrop-blur-sm
  "
>

    <FaTimes className="text-lg sm:text-2xl" />

</button>

{/* HEADER */}

<div className="shrink-0 bg-gradient-to-r from-teal-600 to-emerald-700 px-4 py-4 pr-12 text-white sm:px-8 sm:py-6 sm:pr-8">

<h2 className="text-xl leading-tight font-bold sm:text-3xl">

{forgotPassword
  ? resetStep === 1
    ? "Forgot Password"
    : resetStep === 2
      ? "Verify OTP"
      : "Reset Password"
  : isRegister
    ? role === "candidate"
      ? "Create Job Seeker Account"
      : "Register Hospital / Employer"
    : "Welcome Back"
}

</h2>

<p className="mt-1 text-xs leading-relaxed text-white opacity-90 sm:mt-0 sm:text-lg">
  {forgotPassword
    ? "Securely recover your HireCura account"
    : "India's Premium Healthcare Hiring Platform"}
</p>

</div>

<div className="min-h-0 overflow-y-auto overscroll-contain p-3 sm:p-8">

{/* =====================================
    FORGOT PASSWORD FLOW
===================================== */}

{forgotPassword ? (

  <>

    {/* STEP 1 - EMAIL */}
    {resetStep === 1 && (

      <div>

        <h3 className="mb-2 text-lg font-bold text-gray-800 sm:text-2xl">
          Forgot Password?
        </h3>

        <p className="mb-3 text-xs leading-relaxed text-gray-500 sm:mb-6 sm:text-base">
          Enter your registered email address and we'll send you a
          verification OTP.
        </p>

        <input
          type="email"
          placeholder="Email Address"
          value={resetEmail}
          onChange={(e) => setResetEmail(e.target.value)}
          className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-5 sm:rounded-2xl sm:p-4 sm:text-base"
        />

        <button
          onClick={handleForgotPassword}
          disabled={loading}
          className="w-full rounded-xl bg-gradient-to-r from-teal-600 to-emerald-700 py-3.5 text-base font-bold text-white hover:opacity-90 disabled:opacity-60 sm:rounded-2xl sm:py-4 sm:text-lg"
        >
          {loading ? "Sending OTP..." : "Send OTP"}
        </button>

        <button
          type="button"
          onClick={() => {
            setForgotPassword(false);
            setResetStep(1);
            setResetEmail("");
          }}
          className="mt-3 w-full py-2 text-sm font-semibold text-teal-700 sm:mt-4 sm:text-base"
        >
          ← Back to Login
        </button>

      </div>

    )}

    {/* STEP 2 - OTP */}
    {resetStep === 2 && (

      <div>

        <h3 className="mb-2 text-lg font-bold text-gray-800 sm:text-2xl">
          Verify OTP
        </h3>

        <p className="mb-3 text-xs leading-relaxed text-gray-500 sm:mb-6 sm:text-base">
          Enter the 6-digit OTP sent to:
        </p>

        <p className="font-semibold text-teal-700 mb-5">
          {resetEmail}
        </p>

        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="Enter 6-digit OTP"
          value={resetOtp}
          onChange={(e) =>
            setResetOtp(
              e.target.value.replace(/\D/g, "")
            )
          }
          className="mb-4 w-full min-w-0 rounded-xl border p-3.5 text-center text-xl font-bold tracking-[0.35em] focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-5 sm:rounded-2xl sm:p-4 sm:text-2xl sm:tracking-[0.5em]"
        />

        <button
          onClick={handleVerifyResetOtp}
          disabled={loading}
          className="w-full rounded-xl bg-gradient-to-r from-teal-600 to-emerald-700 py-3.5 text-base font-bold text-white hover:opacity-90 disabled:opacity-60 sm:rounded-2xl sm:py-4 sm:text-lg"
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>

        <button
          type="button"
          onClick={() => {
            setResetStep(1);
            setResetOtp("");
          }}
          className="mt-3 w-full py-2 text-sm font-semibold text-teal-700 sm:mt-4 sm:text-base"
        >
          ← Change Email
        </button>

      </div>

    )}

    {/* STEP 3 - NEW PASSWORD */}
    {resetStep === 3 && (

      <div>

        <h3 className="mb-2 text-lg font-bold text-gray-800 sm:text-2xl">
          Create New Password
        </h3>

        <p className="mb-3 text-xs leading-relaxed text-gray-500 sm:mb-6 sm:text-base">
          Create a new password for your HireCura account.
        </p>

        {/* New Password */}
        <div className="relative mb-4">

          <input
            type={
              showResetPassword
                ? "text"
                : "password"
            }
            placeholder="New Password"
            value={newPassword}
            onChange={(e) =>
              setNewPassword(e.target.value)
            }
            className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm sm:rounded-2xl sm:p-4"
          />

          <button
            type="button"
            onClick={() =>
              setShowResetPassword(!showResetPassword)
            }
            className="absolute right-4 top-4"
          >
            {showResetPassword
              ? <FaEyeSlash />
              : <FaEye />
            }
          </button>

        </div>

        {/* Confirm Password */}
        <div className="relative mb-6">

          <input
            type={
              showConfirmResetPassword
                ? "text"
                : "password"
            }
            placeholder="Confirm New Password"
            value={confirmNewPassword}
            onChange={(e) =>
              setConfirmNewPassword(e.target.value)
            }
            className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm sm:rounded-2xl sm:p-4"
          />

          <button
            type="button"
            onClick={() =>
              setShowConfirmResetPassword(
                !showConfirmResetPassword
              )
            }
            className="absolute right-4 top-4"
          >
            {showConfirmResetPassword
              ? <FaEyeSlash />
              : <FaEye />
            }
          </button>

        </div>

        <button
          onClick={handleResetPassword}
          disabled={loading}
          className="w-full rounded-xl bg-gradient-to-r from-teal-600 to-emerald-700 py-3.5 text-base font-bold text-white hover:opacity-90 disabled:opacity-60 sm:rounded-2xl sm:py-4 sm:text-lg"
        >
          {loading
            ? "Resetting..."
            : "Reset Password"
          }
        </button>

        <button
          type="button"
          onClick={() => {
            setResetStep(2);
            setNewPassword("");
            setConfirmNewPassword("");
          }}
          className="mt-3 w-full py-2 text-sm font-semibold text-teal-700 sm:mt-4 sm:text-base"
        >
          ← Back to OTP
        </button>

      </div>

    )}

  </>

) : (

  <>
{/* ROLE */}

<div className="mb-4 grid grid-cols-2 gap-2 sm:mb-6 sm:gap-4">

<button

onClick={() => setRole("candidate")}

className={`min-h-[64px] rounded-lg border p-2 text-xs transition sm:min-h-0 sm:rounded-2xl sm:p-4 sm:text-base

${role==="candidate"

? "bg-teal-600 text-white border-teal-600"

: "bg-white"

}`}

>

<FaUserMd className="mx-auto mb-1 text-lg sm:mb-2 sm:text-2xl"/>

Job Seeker

</button>

<button

onClick={() => setRole("institution")}

className={`min-h-[64px] rounded-lg border p-2 text-xs transition sm:min-h-0 sm:rounded-2xl sm:p-4 sm:text-base

${role==="institution"

? "bg-teal-600 text-white border-teal-600"

: "bg-white"

}`}

>

<FaHospital className="mx-auto mb-1 text-lg sm:mb-2 sm:text-2xl"/>

Recruiter

</button>

</div>


{/* FREE BANNER */}

{isRegister && role==="institution" && (

<div className="mb-5 flex items-center gap-3 rounded-xl border border-green-300 bg-green-100 p-3 text-sm text-green-700 sm:mb-6 sm:rounded-2xl sm:p-4 sm:text-base">

<FaCheckCircle/>

First 15 Job Posts are FREE.

</div>

)}

{/* LOGIN */}

{/* LOGIN */}

{!isRegister && (
  <>
    <input
      type="text"
      name="phone"
      placeholder={
        role === "candidate"
          ? "Mobile Number"
          : "Recruiter Mobile Number"
      }
      value={form.phone}
      onChange={handleChange}
      className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-5 sm:rounded-2xl sm:p-4 sm:text-base"

    />

    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        placeholder="Password"
        value={form.password}
        onChange={handleChange}
        className="mb-4 w-full min-w-0 rounded-lg border p-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-6 sm:rounded-2xl sm:p-4 sm:text-base"
      />

      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-4 top-4"
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>

    <div className="-mt-2 mb-3 text-right sm:-mt-3 sm:mb-5">
      <button
        type="button"
        onClick={() => {
          setForgotPassword(true);
          setResetStep(1);
          setResetEmail("");
          setResetOtp("");
          setNewPassword("");
          setConfirmNewPassword("");
        }}
        className="text-teal-700 font-semibold hover:underline"
      >
        Forgot Password?
      </button>
    </div>
  </>
)}


{/* JOB SEEKER REGISTRATION */}

{isRegister && role === "candidate" && (
  <>
    <input
      type="text"
      name="name"
      placeholder="Full Name"
      value={form.name}
      onChange={handleChange}
      className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm outline-none focus:ring-2 focus:ring-teal-500 sm:mb-4 sm:rounded-2xl sm:p-4"
    />

    <input
      type="text"
      name="phone"
      placeholder="Mobile Number"
      value={form.phone}
      onChange={handleChange}
      className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-4 sm:rounded-2xl sm:p-4"
    />

    <input
      type="email"
      name="email"
      placeholder="Email Address"
      value={form.email}
      onChange={handleChange}
      className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-4 sm:rounded-2xl sm:p-4"
    />

    <div className="relative mb-4">
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        placeholder="Create Password"
        value={form.password}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4"
      />

      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-4 top-4"
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>

    <div className="relative mb-6">
      <input
        type={showConfirmPassword ? "text" : "password"}
        name="confirmPassword"
        placeholder="Confirm Password"
        value={form.confirmPassword}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4"
      />

      <button
        type="button"
        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        className="absolute right-4 top-4"
      >
        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  </>
)}


{/* RECRUITER REGISTRATION */}

{isRegister && role === "institution" && (
  <>
    <input
      type="text"
      name="organization_name"
      placeholder="Hospital / Organization Name"
      value={form.organization_name}
      onChange={handleChange}
      className="mb-3 w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:mb-4 sm:rounded-2xl sm:p-4"
    />

    <div className="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4">
      <input
        type="email"
        name="email"
        placeholder="Official Email"
        value={form.email}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4 sm:text-base"
      />

      <input
        type="text"
        name="phone"
        placeholder="Mobile Number"
        value={form.phone}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4 sm:text-base"
      />
    </div>

    <div className="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4">
      <select
        name="city"
        value={form.city}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4 sm:text-base"
      >
        <option value="">Select City</option>

        {cities.map(city => (
          <option key={city}>{city}</option>
        ))}
      </select>

      <select
        name="organization_type"
        value={form.organization_type}
        onChange={handleChange}
        className="w-full min-w-0 rounded-lg border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4 sm:text-base"
      >
        <option value="">Organization Type</option>

        {organizationTypes.map(type => (
          <option key={type}>{type}</option>
        ))}
      </select>
    </div>

    <div className="mb-4 grid grid-cols-2 gap-2 sm:mb-6 sm:gap-4">
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Create Password"
          value={form.password}
          onChange={handleChange}
          className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4"
        />

        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-4 top-4"
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      <div className="relative">
        <input
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Confirm Password"
          value={form.confirmPassword}
          onChange={handleChange}
          className="w-full min-w-0 rounded-lg border p-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 sm:rounded-2xl sm:p-4"
        />

        <button
          type="button"
          onClick={() =>
            setShowConfirmPassword(!showConfirmPassword)
          }
          className="absolute right-4 top-4"
        >
          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  </>
)}


{/* LOGIN / REGISTER BUTTON */}

{!forgotPassword && (
  <>
    <button
      onClick={handleSubmit}
      disabled={loading}
      className="w-full rounded-lg bg-gradient-to-r from-teal-600 to-emerald-700 py-3 text-sm font-bold text-white hover:opacity-90 sm:rounded-2xl sm:py-4 sm:text-lg"
    >
      {loading
        ? "Please Wait..."
        : isRegister
          ? role === "candidate"
            ? "Create Account"
            : "Register Free"
          : role === "candidate"
            ? "Login as Job Seeker"
            : "Login as Recruiter"}
    </button>

    <div className="mt-5 text-center sm:mt-6">
      <button
        onClick={() => {
          setIsRegister(!isRegister);
          resetForm();
        }}
        className="px-1 py-1 text-xs font-semibold text-teal-700 sm:text-base"
      >
        {isRegister
          ? "Already have an account? Login"
          : "New user? Create account"}
      </button>
    </div>
  </>
)}

  </>

)}

    </div>

  </div>

</div>

);
}
export default LoginModal;